import type {ValueFragment} from "app/gql/graphqlSchema";
import {EmptyValue} from "app/employee/controlCard/display/EmptyValue";
import {InvalidValue} from "app/employee/controlCard/display/InvalidValue";
import {IonImg} from "@ionic/react";

interface Props {
  value: ValueFragment;
}

export const DisplaySignature = ({value}: Props) => {
  let result: JSX.Element;
  if (value.__typename === "ControlCardSignatureValue") {
    result = <IonImg src={value.signature} />;
  } else if (value.__typename === "ControlCardEmptyValue") {
    result = <EmptyValue />;
  } else {
    result = <InvalidValue />;
  }

  return result;
};
